import { z } from 'zod'

import { CAACountByAvailability } from './CAACountByAvailability'
import { CAACountByCAAType } from './CAACountByCAAType'

export const CAAReport = z.object({
  period: z.string(),
  caa: CAACountByCAAType.array(),
  availabilities: CAACountByAvailability.array()
})
export type CAAReport = z.infer<typeof CAAReport>

export const CAAReportList = CAAReport.array()
export type CAAReportList = z.infer<typeof CAAReportList>
